import { render, staticRenderFns } from "./CasePage.vue?vue&type=template&id=115c9ef9&scoped=true&"
import script from "./CasePage.vue?vue&type=script&lang=js&"
export * from "./CasePage.vue?vue&type=script&lang=js&"
import style0 from "./CasePage.vue?vue&type=style&index=0&id=115c9ef9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115c9ef9",
  null
  
)

export default component.exports